/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const LEGEND_NUMBER_STEP = ({ auth, layer }) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props
  const { geo_layer_list, layer_id } = layer;

  //content
  const current_layer = geo_layer_list.find(
    (item) => item?.geo_layer?._id === layer_id
  )?.geo_layer;
  const style_array = current_layer?.style_array || [];
  const default_style_key = current_layer?.default_style_key || "";
  const style_object = style_array.find(
    (item) => item.key === default_style_key
  );

  const { style_type, paint_object } = style_object;
  let color_key;
  if (style_type === "circle") {
    color_key = "circle-color";
  } else if (style_type === "line") {
    color_key = "line-color";
  } else if (style_type === "fill") {
    color_key = "fill-color";
  }

  let rows = [];
  let array_number_step = paint_object?.[color_key] || [];

  array_number_step = array_number_step.slice(2, array_number_step.length);

  // const test_1 = " ≤ x < ";
  const test_2 = " - ";

  // const test_mid_1 = "x < ";
  const test_mid_2 = " < ";

  // const test_big_1 = "x ≥ ";
  const test_big_2 = "≥ ";

  array_number_step.forEach((item, idx) => {
    if (idx % 2 === 1) {
      rows.push(
        <tr key={idx}>
          <td className="text_right">
            {array_number_step?.[idx - 2] !== undefined
              ? `${array_number_step?.[idx - 2]}${test_2}`
              : test_mid_2}
            {item}
          </td>
          <td style={{ width: "20px", verticalAlign: "middle" }}>
            <div
              style={{
                backgroundColor: array_number_step?.[idx - 1], // Color is at the next index
                width: "20px",
                height: "20px",
                border: "1px solid black",
                margin: "auto",
              }}
            />
          </td>
        </tr>
      );
    }
  });

  rows.push(
    <tr key="last">
      <td className="text_right">
        {test_big_2}
        {array_number_step?.[array_number_step.length - 2]}
      </td>
      <td style={{ width: "20px", verticalAlign: "middle" }}>
        <div
          style={{
            backgroundColor: array_number_step?.[array_number_step.length - 1],
            width: "20px",
            height: "20px",
            border: "1px solid black",
            margin: "auto",
          }}
        />
      </td>
    </tr>
  );

  return (
    <main style={{ maxHeight: "250px", overflowY: "scroll" }}>
      <table className="table full_width">
        <thead>
          <tr>
            <th>{dict?.["Range"]?.[language]}</th>
            <th>{dict?.["Color"]?.[language]}</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  properties: state.properties,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {})(LEGEND_NUMBER_STEP);
